import { QUESTION_TYPE } from './actionTypes'

export const questionType = (token) => {

    return {
        type: QUESTION_TYPE,
        payload: token
    }

}